import { render, staticRenderFns } from "./CarContainer.vue?vue&type=template&id=194842ae&scoped=true&"
import script from "./CarContainer.vue?vue&type=script&lang=js&"
export * from "./CarContainer.vue?vue&type=script&lang=js&"
import style0 from "./CarContainer.vue?vue&type=style&index=0&id=194842ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194842ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSkeletonLoader})
